export default "__VITE_ASSET__Cse6LIYy__"